'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Children, isValidElement, cloneElement } from 'react';
import { tokensRaw } from '../../../core/tokens/tokens-raw.js';
import { ThumbnailsHeroVideoThumbnailSlide } from './thumbnails-hero-video-thumbnail-slide.component.js';
import { useInternalOptionalSwanI18nContext } from '../../contexts/i18n/swan-i18n-provider.context.js';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { useRequiredI18nProps, getDeprecatedI18nPropMessage } from '../../hooks/use-required-i18n-props.js';
import { ThumbnailsHeroBackgroundContainer } from './thumbnails-hero-background-container.component.js';
import { ThumbnailsHeroContentContainer } from './thumbnails-hero-content-container.component.js';
import { ThumbnailsHeroImagesSlidesContainer } from './thumbnails-hero-images-slides-container.component.js';
import { ThumbnailsHeroThumbnailsSlidesContainer } from './thumbnails-hero-thumbnails-slides-container.component.js';
import { Carousel } from '../carousel/carousel.component.js';
import { deprecatedComponent } from '../core/deprecated-component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { CarouselSlide } from '../carousel/carousel-slide.component.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(e, o) {
    if (null == e) return {};
    var r, t, s = _object_without_properties_loose(e, o);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(t = 0; t < n.length; t++)r = n[t], !(o.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (s[r] = e[r]);
    }
    return s;
}
function _object_without_properties_loose(e, o) {
    if (null == e) return {};
    var r, t, s = {}, n = Object.keys(e);
    for(t = 0; t < n.length; t++)r = n[t], o.indexOf(r) >= 0 || (s[r] = e[r]);
    return s;
}
let k = renderWithRef('ThumbnailsHero', null, (l, p)=>{
    useComponentStylesLoaded('ThumbnailsHero', SWAN_STYLE_KEY_MAP.thumbnailsHero);
    let { currentSlide: k = 0, accessibleTextForDots: T, onSlideChange: j, children: v } = l, S = _object_without_properties(l, [
        "currentSlide",
        "accessibleTextForDots",
        "onSlideChange",
        "children"
    ]), O = useInternalOptionalSwanI18nContext();
    useRequiredI18nProps(l, [
        'accessibleTextForDots'
    ]);
    let F = T;
    O && !T && (F = Array.from({
        length: Children.toArray(v).length
    }, (e, o)=>O.t('carousel.accessible-text-for-dot-button', {
            slideNumber: o + 1
        }))), useDeprecatedProps('ThumbnailsHero', l, [
        {
            propName: 'accessibleTextForDots',
            instructions: getDeprecatedI18nPropMessage(O)
        }
    ]);
    let H = [], N = [], A = null, D = null;
    return Children.forEach(v, (e)=>{
        if (isValidElement(e)) switch(e.type){
            case ThumbnailsHeroThumbnailsSlidesContainer:
                H.push(...Children.map(e.props.children, (e, o)=>[
                        CarouselSlide,
                        ThumbnailsHeroVideoThumbnailSlide
                    ].includes(e.type) ? cloneElement(e, {
                        key: o,
                        component: e.props.component || 'span'
                    }) : null));
                break;
            case ThumbnailsHeroImagesSlidesContainer:
                N.push(...Children.map(e.props.children, (e, o)=>e.type === CarouselSlide ? cloneElement(e, {
                        key: o
                    }) : null));
                break;
            case ThumbnailsHeroBackgroundContainer:
                A = e;
                break;
            case ThumbnailsHeroContentContainer:
                D = e;
        }
    }), jsxs(RenderComp, {
        root: "div",
        forwardedRef: p,
        classNames: new Set([
            'swan-thumbnails-hero'
        ]),
        props: S,
        children: [
            A,
            jsx("div", {
                className: "swan-thumbnails-hero-images-carousel-container",
                children: jsx(Carousel, {
                    slidesToScroll: 1,
                    slidesToShow: 1,
                    arrows: false,
                    accessibleTextForNext: "",
                    accessibleTextForPrevious: "",
                    __dangerouslySuppressWarning: true,
                    accessibleTextForDots: T,
                    customPaging: (o)=>jsx("button", {
                            "aria-label": F[o],
                            children: H[o]
                        }, o),
                    progressIndicator: 'dots',
                    progressIndicatorAlignment: 'left',
                    currentSlide: null != k ? k : 0,
                    beforeChange: null != j ? j : void 0,
                    fade: true,
                    responsive: [
                        {
                            breakpoint: parseInt(tokensRaw.SwanBaseBreakpointMdStart, 10),
                            settings: {
                                fade: false
                            }
                        }
                    ],
                    children: N
                })
            }),
            D
        ]
    });
});
const ThumbnailsHero = deprecatedComponent({
    description: 'Use AdaptiveCarousel instead',
    displayName: 'ThumbnailsHero',
    root: k
});

export { ThumbnailsHero };
